module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge"
  }, [_c('div', {
    staticClass: "meter",
    style: ('transform: rotate(' + _vm.rotation + 'turn);')
  }), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v("\n    " + _vm._s(_vm.percentage) + "%\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c155eab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/Gauge.vue
// module id = 1988
// module chunks = 0